Object.assign(Datepicker.locales, Datepicker.locales.ru);

$('.js-inline-datepicker').each((index, element) => {
    const options = JSON.parse(element.dataset.options || '{}');
    new Datepicker(element, {
        language: 'ru',
        minDate: new Date(),
        prevArrow: '<svg class="icon24" focusable="false" fill="currentColor"> <use xlink:href="/static/i/svg/icons.svg#icon-arrow-left"></use></svg>',
        nextArrow: '<svg class="icon24" focusable="false" fill="currentColor"> <use xlink:href="/static/i/svg/icons.svg#icon-arrow-right"></use></svg>',
        ...options,
        datesDisabled: function(date) {
            return !checkDateAvailability(
                convertFromRuLocaleDateList(options.datesAvailable),
                convertFromRuLocaleDateList(options.datesDisabled),
                date
            );
        }
    });
});
